import React from 'react';
import { connect } from 'react-redux';
import { GoogleProvider } from 'leaflet-geosearch';
import Geocode from "react-geocode";

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Input from '../../components/Input/Input';
import { fetchLocation, updateLocation } from '../../store/actions/location';
import Map from '../../components/Map/Map';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import { setMessage } from '../../store/actions/general';

const styles = theme => ({
  map: {
    position: 'relative',
    zIndex: '1',
  },
  card: {
    position: 'absolute',
    backgroundColor: 'white',
    top: '90px',
    left: '20px',
    zIndex: '200',
    height: 'auto',
    width: '360px',
  },
  cardContent: {
    padding: '20px',
    paddingTop: '5px',
  },
  container: {
    position: 'relative',
  },
  button: {
    marginTop: '15px',
  },
  slider: {
    display: 'inline-block',
    backgroundColor: theme.palette.primary.contrastText,
    marginTop: '20px',
    width: '200px',
    height: '15px',
    borderRadius: '5px',
    color: theme.palette.primary.main,
    outline: 'none',
    opacity: '0.5',
    transition: 'opacity .2s',
    '-webkit-appearence': 'none',
  },
  sliderText: {
    display: 'inline-block',
    width: '110px',
    textAlign: 'left',
  },
});

class CreateLocation extends React.Component {
  state = {
    value: 0,
    address: '',
    addressSearch: '',
    provider: new GoogleProvider({
      params: {
        key: 'AIzaSyAeaAPf9Ghck4OWSfBOFMOkn43PAJyj3Bs',
      },
    }),
    location: {
      address: '',
      id: null,
      description: '',
      lat: null,
      lng: null,
      range: '100',
    },
    searchLoading: false,
    addressPoint: '',
  };

  componentDidMount() {
    this.props.onFetchLocation(this.props.match.params.id).then(() => {
      const newLocation = { ...this.state.location };
      newLocation.lat = this.props.locationData.lat;
      newLocation.lng = this.props.locationData.lng;
      newLocation.description = this.props.locationData.description;
      newLocation.range = this.props.locationData.range;
      newLocation.id = this.props.locationData.id;
      newLocation.address = this.props.locationData.address;
      this.setState({ location: newLocation });
      this.handleAddressPoint();
    });
  }

  handleAddress = (event) => {
    const newLocation = { ...this.state.location };
    newLocation.address = event.target.value;
    this.setState({ address: event.target.value });
    this.setState({ location: newLocation });
  };

  handleDescription = (event) => {
    const newLocation = { ...this.state.location };
    newLocation.description = event.target.value;
    this.setState({ location: newLocation });
  };

  handleRadius = (event) => {
    const newLocation = { ...this.state.location };
    newLocation.range = event.target.value;
    this.setState({ location: newLocation });
  };

  handleSearch = () => {
    this.setState({ searchLoading: true });
    const newLocation = { ...this.state.location };
    this.state.provider.search({ query: this.state.address }).then((result) => {
      if (result[0]) {
        newLocation.lat = result[0].y;
        newLocation.lng = result[0].x;
        this.setState({ location: newLocation });
        this.setState({ addressSearch: result[0].label });
        this.setState({ searchLoading: false });
      } else {
        this.setState({ searchLoading: false });
        this.props.onMessage('Endereço não encontrado');
      }
    });
  };

  handleAddressPoint = () => {
    Geocode.setApiKey("AIzaSyAeaAPf9Ghck4OWSfBOFMOkn43PAJyj3Bs");
    Geocode.fromLatLng(this.state.location.lat, this.state.location.lng).then(
      (response) => {
        const address = response.results[0].formatted_address;
        this.setState({ addressPoint: address });
        const newLocation = { ...this.state.location };
        newLocation.address = address;
        this.setState({ location: newLocation });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleSearch();
    }
  };

  handlePosition = (newPosition) => {
    const newLocation = { ...this.state.location };
    newLocation.lat = newPosition.lat;
    newLocation.lng = newPosition.lng;
    this.setState({ location: newLocation });
    this.setState({ address: '' });
    this.handleAddressPoint();
  };

  handleAddressValue = (event) => {
    const newAddress = event.target.value;
    this.setState({
      address: newAddress,
      addressPoint: newAddress, // atualiza o estado addressPoint com o novo valor
    });
  }

  render() {
    const { classes, loading } = this.props;
    const { location, searchLoading, addressPoint } = this.state;

    return (
      <div className={classes.container}>
        <ContentHeader
          title="Editar local"
          subtitle="Informe o endereço para atualizar o local desejado"
        />
        <div className={classes.map}>
          <Map
            position={
              location.lat !== null ? [Number(location.lat), Number(location.lng)] : undefined
            }
            radius={Number(location.range)}
            handlePosition={this.handlePosition}
            zoomPosition={location.lat !== null ?true:false}
          />
        </div>
        <Paper elevation={2} className={classes.card}>
          <div className={classes.cardContent}>
            <Tabs value={this.state.value} indicatorColor="primary" textColor="primary" centered>
              <Tab label="Mapa" />
            </Tabs>
            <Input
              elementType="input"
              value={location.description}
              onChange={this.handleDescription}
              type="text"
              label="Descrição"
              margin="normal"
              required
              fullWidth
            />
            <Input
              elementType="search"
              // value={this.state.address || this.state.addressPoint}
              onChange={(event) => {
                this.handleAddress(event);
                this.handleAddressValue(event);
              }}
              handleSearch={this.handleSearch}
              onKeyPress={this.handleKeyPress}
              loading={searchLoading}
              label="Buscar endereço"
              margin="normal"
              required
              fullWidth
            />

            {this.state.addressPoint || this.state.address !== '' ?
              (<Typography>Endereço completo: {addressPoint || this.state.address}</Typography>) : ""}

            <div style={{ display: 'inline-block' }}>
              <Typography variant="h6" color="primary" className={classes.sliderText}>
                Distância
              </Typography>

              <input
                type="range"
                min="50"
                max="1000"
                value={location.range}
                onChange={this.handleRadius}
                className={classes.slider}
                step="50"
              />

              <Typography align="right" color="textSecondary">{`${location.range}m`}</Typography>
            </div>

            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
              onClick={() =>
                this.props
                  .onUpdateLocation(location)
                  .then(() => this.props.history.push('/locais'))
                  .catch(error => error)
              }
              className={classes.button}
              disabled={location.description === '' || loading}
            >
              {loading ? <CircularProgress size={20} color="primary" /> : 'ATUALIZAR'}
            </Button>
          </div>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  locationData: state.location.locationData,
});

const mapDispatchToProps = dispatch => ({
  onFetchLocation: id => dispatch(fetchLocation(id)),
  onUpdateLocation: location => dispatch(updateLocation(location)),
  onMessage: message => dispatch(setMessage(message)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(CreateLocation));
